import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { BRIEF_SCRIPTING_QUERY_KEY } from "@entities/brief/lib/constants";
import {
  IGetScriptingResponse,
  IUpdateScripting,
} from "@shared/lib/types/briefCampains";
import { BriefConfigService } from "../../services/briefConfigService";

export type UpdateScriptingBasicParams = IUpdateScripting & {
  silent?: boolean;
};

export function useUpdateScriptingBasic(
  scriptId: string,
  options?: {
    onSuccess?: (variables: UpdateScriptingBasicParams) => void;
  }
) {
  const {
    mutate: updateBasic,
    isLoading: isUpdating,
    isSuccess: isUpdated,
    variables,
  } = useMutation({
    mutationFn: (payload: UpdateScriptingBasicParams) => {
      const { silent: _silent, ...data } = payload;
      return BriefConfigService.updateScriptingBasic(data).catch(async (err) => {
        const responseBody = await err.response?.json?.();
        if (responseBody?.msg) ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      skipInvalidation: true,
    },
    onSuccess: (queryClient, _data, variables) => {
      const id = scriptId || variables.scriptId;
      if (id) {
        queryClient.setQueryData(
          BRIEF_SCRIPTING_QUERY_KEY(id),
          (oldData: BackednResponse<IGetScriptingResponse> | undefined) => {
            if (!oldData?.data?.script) return oldData;
            return {
              ...oldData,
              data: {
                ...oldData.data,
                script: {
                  ...oldData.data.script,
                  ...(variables.concept !== undefined
                    ? { concept: variables.concept }
                    : {}),
                  ...(variables.title !== undefined
                    ? { title: variables.title }
                    : {}),
                },
              },
            };
          }
        );
      }
      options?.onSuccess?.(variables);
    },
  });

  return { updateBasic, isUpdating, isUpdated, variables };
}
